// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"381":"b62b3a27","661":"e2bf6ac4","722":"14b731fd","933":"4554f254"}[chunkId] + ".chunk.css";
};